<template>
  <v-main>
    <v-container class="full-width menu" style="height: 100%">
      <v-row style="height: 100%">
        <v-main>
          <v-container class="fill-height" :fluid="true">
            <v-layout>
              <router-view />
            </v-layout>
          </v-container>
        </v-main>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      currentLayout: null,
    };
  },
  computed: {
    ...mapGetters(["getCountryCode"]),
    ...mapState("app", [
      "product",
      "isContentBoxed",
      "menuTheme",
      "toolbarTheme",
      "isToolbarDetached",
      "globalTheme",
    ]),
  },
  methods: {
    getContent(component) {
      if (this.$router.currentRoute.fullPath != "/" + component)
        this.$router.push("/" + component);
    },
  },
};
</script>

<style scoped>
.full-width {
  max-width: 100%;
}
</style>